import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { CommonFilesApiService } from '@common/generated-api/services/common-files-api.service';

@Directive({
  selector: '[appFileError]',
})
export class FileErrorDirective implements OnInit {
  @Input('appFileError') fileGUID: string;

  constructor(private el: ElementRef, private commonFilesApiService: CommonFilesApiService) {}

  ngOnInit(): void {
    this.el.nativeElement.onerror = (e) => {
      const src = this.el.nativeElement.src;
      if (!src) {
        return;
      }
      this.el.nativeElement.onerror = () => {};
      if (this.fileGUID) {
        this.commonFilesApiService.getFile({ uuid: this.fileGUID }).subscribe({
          next: (data) => {
            if (data.result.url) {
              this.el.nativeElement.src = data.result.url;
            }
          },
        });
      }
    };
  }
}
